import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgConditionTicket = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15 6.125V3.375C15 2.61187 14.37 2 13.6 2H2.4C1.6268 2 1 2.61561 1 3.375V6.125C1.777 6.125 2.4 6.74375 2.4 7.5C2.4 8.25939 1.7732 8.875 1 8.875V11.625C1 12.3844 1.6268 13 2.4 13H13.6C14.3732 13 15 12.3844 15 11.625V8.875C14.2268 8.875 13.6 8.25939 13.6 7.5C13.6 6.74061 14.2268 6.125 15 6.125Z",
		fill: "#4384F5"
	})
});
export default SvgConditionTicket;
